import { Subject } from 'rxjs';

export class DialogToggle<R> {

    private readonly afterClosed = new Subject<R>();
    public afterClosed$ = this.afterClosed.asObservable();

    public notifyClose(r?: R) {
        this.afterClosed.next(r);
    }

}
